/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Event_OverlapInputs */

const en_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event overlaps with another event.`)
};

const fr_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evenement se chevauche avec un autre evenement.`)
};

const de_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Veranstaltung überschneidet sich mit einer anderen Veranstaltung.`)
};

const it_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evento si sovrappone a un altro evento.`)
};

const ru_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одно событие частично совпадает с другим событием.`)
};

const es_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento se superpone con otro evento.`)
};

const zh_cn2_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件与其他事件重叠。`)
};

const ja_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントが別のイベントと重複しています。`)
};

const hi_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह घटना किसी अन्य घटना के साथ ओवरलैप हो रही है।`)
};

const pt_pt2_error_nav_event_overlap = /** @type {(inputs: Error_Nav_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento coincide com outro evento.`)
};

/**
* | output |
* | --- |
* | "Event overlaps with another event." |
*
* @param {Error_Nav_Event_OverlapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_overlap = /** @type {((inputs?: Error_Nav_Event_OverlapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_OverlapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_event_overlap(inputs)
	if (locale === "de") return de_error_nav_event_overlap(inputs)
	if (locale === "it") return it_error_nav_event_overlap(inputs)
	if (locale === "ru") return ru_error_nav_event_overlap(inputs)
	if (locale === "es") return es_error_nav_event_overlap(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_event_overlap(inputs)
	if (locale === "ja") return ja_error_nav_event_overlap(inputs)
	if (locale === "hi") return hi_error_nav_event_overlap(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_event_overlap(inputs)
	return en_error_nav_event_overlap(inputs)
});